{
  "version": 1,
  "asset_id": "326959ad-c885-4d0f-960d-30e6bfe91f5c",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/326959ad-c885-4d0f-960d-30e6bfe91f5c/home-video-2-poster.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/326959ad-c885-4d0f-960d-30e6bfe91f5c/home-video-2-poster.jpg",
  "original_filename": "home-video-2-poster.jpg",
  "size": 139239,
  "content_type": "image/jpeg",
  "created_at": "2026-08-31T21:19:22Z"
}
